export const GET_PROPERTIES = "get_properties";
export const REFRESH_PROPERTIES = "refresh_properties";
export const GET_PROPERTIES_SUCCESS = "get_properties_success";
export const GET_PROPERTIES_FAIL = "get_properties_fail";

export const SET_ACTIVE_PROPERTY = "set_active_property";

export const EDIT_PROPERTY_MAP_OPTIONS = "edit_property_map_options";
